<!-- Компактная строка автора и времени создания под заголовком пометки. -->
<template>
  <div class="vehicle-remark-author">
    <span>
      Добавил
      <span class="vehicle-remark-author__name">
        {{ author?.initials || "Пользователь" }}
      </span>
    </span>
    <time :datetime="createdAt">{{ formatDate(createdAt) }}</time>
  </div>
</template>
<script>
import { formatDateAndTimeLocal } from "@/utils/dateUtils";
export default {
  name: "VehicleRemarkDetailsAuthorLine",
  props: {
    author: { type: Object, default: null },
    createdAt: { type: String, required: true },
  },
  methods: { formatDate: formatDateAndTimeLocal },
};
</script>
<style scoped>
.vehicle-remark-author {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  column-gap: 14px;
  row-gap: 4px;
  color: #8995a7;
  font-size: 12px;
  line-height: 1.5;
}
.vehicle-remark-author__name {
  color: #64748b;
}
</style>
